import React from "react"
import CircularProgress from "@mui/material/CircularProgress"
import Overlay from "./Overlay"

export default function LoadingOverlay({
    shouldBlurBackground = true,
    opacity = 0.9,
}) {
    return (
        <Overlay shouldBlurBackground={shouldBlurBackground} opacity={opacity}>
            <CircularProgress />
        </Overlay>
    )
}
